import { all } from 'redux-saga/effects';
import mailSagas from './Mail';
import toDoSagas from './Todo';
import contactSagas from './Contact';
import chatSagas from './Chat';
import authSagas from './Auth';
import orgSagas from './Organisation';
import empSagas from './Employee';
import orgSurveySagas from './OrgSurvey';
import orgSurveyAnswerSagas from './OrgSurveyAnswer';
import surveySagas from './Survey';
import surveyGroupSagas from './SurveyGroup';
import surveyGroupQuestionSagas from './SurveyGroupQuestion';
import surveyQuestionSagas from './SurveyQuestion';
import projectSagas from './project';
import projectPrioritySagas from './projectPriority';
import securitySagas from './security';
import projectIssueSagas from './projectIssue';
import businessUnitSagas from './businessUnit';
import portfolioSagas from './portfolio';
import featureSagas from './feature';
import valueStreamSagas from './valueStream';
import memberSagas from './member';
import teamSagas from './team';
import productSagas from './product';
import initiativeSagas from './initiative';
import issueSagas from './issue';
import projectBusPrioritySagas from './projectBusPriority';
import projectCostPrioritySagas from './projectCostPriority';

export default function* rootSaga () {
    yield all ([
        mailSagas (),
        toDoSagas (),
        contactSagas (),
        chatSagas (),
        authSagas (),
        orgSagas(),
        empSagas(),
        orgSurveySagas(),
        orgSurveyAnswerSagas(),
        surveySagas(),
        surveyGroupSagas(),
        surveyGroupQuestionSagas(),
        surveyQuestionSagas(),
        projectSagas(),
        projectPrioritySagas(),
        securitySagas(),
        projectIssueSagas(),
        businessUnitSagas(),
        portfolioSagas(),
        featureSagas(),
        valueStreamSagas(),
        memberSagas(),
        teamSagas(),
        productSagas(),
        initiativeSagas(),
        issueSagas(),
        projectBusPrioritySagas(),
        projectCostPrioritySagas(),
    ]);
}



// WEBPACK FOOTER //
// ./sagas/index.js